import { ReactNode } from 'react';
import styles from './LandingDiscountChip.module.css';

type Props = {
  children?: ReactNode;
};

export function LandingDiscountChip({ children }: Props) {
  return <span className={styles.root}>{children}</span>;
}
